export const LOGIN_USER = 'LOGIN_USER';
export const SIGNUP_USER = 'SIGNUP_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_FOODS = 'GET_FOODS';
export const ADD_FOOD = 'ADD_FOOD';
export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const GET_MEALS = 'GET_MEALS';
export const ADD_FOODS = 'ADD_FOODS';
